import React, { useState } from "react";
import { useParams } from "react-router-dom";

// components
import ActionButton from "../../../components/buttons/ActionButton/ActionButton.component";
import DeleteObjectWithModal from "../../../blockGroups/deletion/DeleteObjectWithModal/DeleteObjectWithModal.blockgroup";

// collections
import CrewDetailNameAndIsForeman from "./collections/CrewDetailNameAndIsForeman/CrewDetailNameAndIsForeman.collection";
import CrewDetailCertifications from "./collections/CrewDetailCertifications/CrewDetailCertifications.collection";
import CrewDetailProfile from "./collections/CrewDetailProfile/CrewDetailProfile.collection";
import CrewDetailEmergencyContacts from "./collections/CrewDetailEmergencyContacts/CrewDetailEmergencyContacts.collection";
import CrewDetailAssignments from "./collections/CrewDetailAssignments/CrewDetailAssignments.collection";

// forms
import EditCrewMemberFormController from "./forms/EditCrewMember.form.controller";

// query
import { GET_CREW_MEMBER_BY_ID_WITH_ASSIGNMENTS } from "../../../graphql/crewMember/crewMember.queries";

// wrapper
import WithGqlQuery from "../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper";

// graphql mutations
import { DELETE_CREW_MEMBER } from "../../../graphql/crewMember/crewMember.mutations";

// mui
import { Container, Grid } from "@mui/material";

export default function CrewDetail() {
  const { crewMemberId } = useParams();
  const [showEditModal, setShowEditModal] = useState(false);
  const crewMemberIdNum = parseInt(crewMemberId, 10);

  return (
    <div id="CrewDetail">
      <EditCrewMemberFormController
        id={crewMemberIdNum}
        visible={showEditModal}
        closeForm={() => setShowEditModal(false)}
      />

      <Container maxWidth="lg" sx={{ marginBottom: 4 }} disableGutters>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={6}>
            <CrewDetailNameAndIsForeman id={crewMemberIdNum} />
          </Grid>
          <Grid item xs={6} textAlign="right">
            <ActionButton label="Edit" onClick={() => setShowEditModal(true)} />
          </Grid>
        </Grid>
      </Container>

      <CrewDetailCertifications id={crewMemberIdNum} />

      <Container maxWidth="lg" disableGutters>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={6}>
            <CrewDetailProfile id={crewMemberIdNum} />
          </Grid>
          <Grid item xs={6}>
            <CrewDetailEmergencyContacts id={crewMemberIdNum} />
          </Grid>
        </Grid>
      </Container>

      <WithGqlQuery
        component={CrewDetailAssignments}
        query={GET_CREW_MEMBER_BY_ID_WITH_ASSIGNMENTS}
        variables={{ id: crewMemberIdNum }}
      />

      {/* DELETE SECTION - Just add the entityName and redirectPath props */}
      <DeleteObjectWithModal
          id={crewMemberIdNum}
          mutation={DELETE_CREW_MEMBER}
          deleteLabel="Delete Crew Member"
          deleteTitle="Delete Crew Member"
          deleteMessage="Are you sure you want to delete this Crew Member? This will delete all Emergency Contacts, Certifications, and Assignments associated with this Crew Member."
          successObjectKey="deleteCrewMember"
          entityName="Crew Member"
      />
    </div>
  );
}
